export class ResetUserPassword {
    Id: number;
    Tenant: number;
    Password: string;
}